import { useContext, useState } from 'react';
import {
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Add } from '@mui/icons-material';
import ShoppingListContext from '../../context/shopping-list-context';
import ShoppingListView from '../../components/ShoppingList/ShoppingListView';
import Loader from '../../components/UI/General/Loader';

const ShoppingListPage = () => {
  const { entries, isLoading, clearAll, addCustomItem } = useContext(ShoppingListContext);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [clearing, setClearing] = useState(false);
  const [newItem, setNewItem] = useState('');
  const [adding, setAdding] = useState(false);

  const handleClear = async () => {
    setClearing(true);
    try {
      await clearAll();
    } finally {
      setClearing(false);
      setConfirmOpen(false);
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Container maxWidth="sm" sx={{ mt: 2 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="h5">Nákupní seznam</Typography>
        {entries.length > 0 && (
          <Button variant="outlined" color="error" size="small" onClick={() => setConfirmOpen(true)}>
            Vymazat vše
          </Button>
        )}
      </Stack>

      <Stack
        direction="row"
        spacing={1}
        sx={{ mb: 2 }}
        component="form"
        onSubmit={async (e: React.FormEvent) => {
          e.preventDefault();
          if (!newItem.trim() || adding) return;
          setAdding(true);
          try {
            await addCustomItem(newItem.trim());
            setNewItem('');
          } finally {
            setAdding(false);
          }
        }}
      >
        <TextField
          size="small"
          placeholder="Přidat položku..."
          value={newItem}
          onChange={(e) => setNewItem(e.target.value)}
          fullWidth
        />
        <IconButton type="submit" disabled={!newItem.trim() || adding} color="primary">
          <Add />
        </IconButton>
      </Stack>

      <ShoppingListView />

      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>Vymazat nákupní seznam</DialogTitle>
        <DialogContent>
          <DialogContentText>Opravdu chcete vymazat celý nákupní seznam? Tato akce je nevratná.</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)} disabled={clearing}>
            Zrušit
          </Button>
          <Button onClick={handleClear} color="error" disabled={clearing}>
            {clearing ? 'Mazání...' : 'Vymazat'}
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default ShoppingListPage;
